import React from 'react';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from '@material-ui/core/Button';

import { AccentColor } from 'helpers/AccentColorHelper';
import { toDate, toFriendlyDateString } from 'helpers/Formatter';

class ReferralReviewDialog extends React.Component {
  render() {
    const { data } = this.props;
    const referrer = data && data.referrer ? data.referrer : {};

    return (
      <Dialog
        fullScreen={this.props.fullScreen}
        open={this.props.open}
        onClose={this.props.toggleOpen}
        aria-labelledby="review-referral"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="review-referral">
          <h3 style={{ textAlign: 'center', margin: 0 }}>Review Referral</h3>
        </DialogTitle>

        <DialogContent>
          <div className="row">
            <div className="col-xs-12" style={{ marginBottom: '15px' }}>
              <p>
                Below is the information regarding a referred application. If the referral process
                has been completed you can mark this referral as complete
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
              <p>
                <strong style={{ marginRight: '5px' }}>Referral for: </strong>
                <span>{data.unit_name}</span>
              </p>
            </div>
            <div className="col-sm-6 col-sm-offset-3">
              <p>
                <strong style={{ marginRight: '5px' }}>Date Referred: </strong>
                <span>{toFriendlyDateString(toDate(data.date_referred))}</span>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
              <p>
                <strong style={{ marginRight: '5px' }}>Referred by: </strong>
                <span>
                  {referrer.name} - {referrer.unit_name}
                </span>
              </p>
            </div>
          </div>
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.props.toggleOpen}
            id="close-button"
            style={{ color: AccentColor() }}
          >
            CANCEL
          </FlatButton>

          <FlatButton
            variant="raised"
            onClick={() => this.props.onSubmit(data.lead_card_id, true)}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: AccentColor(),
            }}
          >
            MARK SUCCESFUL
          </FlatButton>
          <FlatButton
            onClick={() => this.props.onSubmit(data.lead_card_id, false)}
            id="close-button"
            style={{ color: AccentColor(), float: 'right' }}
          >
            MARK UNSUCCESFUL
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(ReferralReviewDialog);
